'use es6';

import Products from 'merchandise-lib/constants/Product';
import { ADS, BREEZE_INTELLIGENCE_CREDITS_100, BREEZE_INTELLIGENCE_CREDITS_1000, BREEZE_INTELLIGENCE_CREDITS_10000, BREEZE_INTELLIGENCE_CREDITS_10000_COMMITTED, BREEZE_INTELLIGENCE_CREDITS_1000_COMMITTED, BREEZE_INTELLIGENCE_CREDITS_100_COMMITTED, BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_100, BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_1000, BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_10000, CALCULATED_PROPERTIES_LIMIT_INCREASE, CALLING_LIMIT_INCREASE, CMS_ENTERPRISE, CMS_PROFESSIONAL, CMS_STARTER, COMMERCE_ENTERPRISE, COMMERCE_PROFESSIONAL, CORE_SEATS_ENTERPRISE, CORE_SEATS_PROFESSIONAL, CORE_SEATS_STARTER, CRM_CONTACT_RECORDS_LIMIT_INCREASE, CRM_OBJECT_LIMIT_INCREASE, CUSTOM_OBJECTS_LIMIT_INCREASE, CUSTOM_PROPERTIES_LIMIT_INCREASE, CUSTOM_SSL, DEDICATED_IP, DOMAINS_LIMIT_INCREASE, ESIGNATURE_LIMIT_INCREASE, HUBSPOT_CREDITS_COMMITTED, HUBSPOT_CREDITS_COMMITTED_OVERAGE, HUBSPOT_CREDITS_OVERAGE, MARKETING_ENTERPRISE, MARKETING_PLUS_ENTERPRISE, MARKETING_PLUS_PROFESSIONAL, MARKETING_PRO, MARKETING_SMS_ADDON, MARKETING_SMS_SHORT_CODE, MARKETING_STARTER, MARKETING_STARTER_EMAIL, OPERATIONS_ENTERPRISE, OPERATIONS_PROFESSIONAL, OPERATIONS_STARTER, PHONE_LIMIT_INCREASE, REPORTING, SALES_ENTERPRISE, SALES_PROFESSIONAL, SALES_STARTER, SANDBOX_LIMIT_INCREASE, SERVICE_ENTERPRISE, SERVICE_PROFESSIONAL, SERVICE_STARTER, STARTER_CONTACTS, SUITE_ENTERPRISE, SUITE_PROFESSIONAL, SUITE_STARTER, TEAMS_LIMIT_INCREASE, VIDEO_LIMIT_INCREASE, WHATSAPP_LIMIT_INCREASE, WORKFLOWS_ADDON } from './UpgradeProducts';

/**
 * @note keep in sync with ApiNameToUpgradeProductMap
 */
const UpgradeProductToApiNameMap = {
  [SALES_STARTER]: Products.SALES_HUB_STARTER,
  [SALES_PROFESSIONAL]: Products.SALES_HUB_PROFESSIONAL,
  [SALES_ENTERPRISE]: Products.SALES_HUB_ENTERPRISE,
  [MARKETING_STARTER_EMAIL]: Products.MARKETING_HUB_STARTER,
  [MARKETING_STARTER]: Products.MARKETING_HUB_STARTER,
  [MARKETING_PRO]: Products.MARKETING_HUB_PROFESSIONAL,
  [MARKETING_ENTERPRISE]: Products.MARKETING_HUB_ENTERPRISE,
  [SERVICE_STARTER]: Products.SERVICE_HUB_STARTER,
  [SERVICE_PROFESSIONAL]: Products.SERVICE_HUB_PROFESSIONAL,
  [SERVICE_ENTERPRISE]: Products.SERVICE_HUB_ENTERPRISE,
  [CMS_STARTER]: Products.CMS_HUB_STARTER,
  [CMS_PROFESSIONAL]: Products.CMS_HUB_PROFESSIONAL,
  [CMS_ENTERPRISE]: Products.CMS_HUB_ENTERPRISE,
  [OPERATIONS_STARTER]: Products.OPERATIONS_HUB_STARTER,
  [OPERATIONS_PROFESSIONAL]: Products.OPERATIONS_HUB_PROFESSIONAL,
  [OPERATIONS_ENTERPRISE]: Products.OPERATIONS_HUB_ENTERPRISE,
  [CORE_SEATS_STARTER]: Products.CORE_SEATS_STARTER,
  [CORE_SEATS_PROFESSIONAL]: Products.CORE_SEATS_PROFESSIONAL,
  [CORE_SEATS_ENTERPRISE]: Products.CORE_SEATS_ENTERPRISE,
  [SUITE_STARTER]: Products.CRM_SUITE_STARTER_BUNDLE,
  [SUITE_PROFESSIONAL]: Products.CRM_SUITE_PROFESSIONAL_BUNDLE,
  [SUITE_ENTERPRISE]: Products.CRM_SUITE_ENTERPRISE_BUNDLE,
  [MARKETING_PLUS_PROFESSIONAL]: Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL,
  [MARKETING_PLUS_ENTERPRISE]: Products.MARKETING_PLUS_SUITE_BUNDLE_ENTERPRISE,
  [ADS]: Products.ADS_LIMIT_INCREASE,
  [CUSTOM_OBJECTS_LIMIT_INCREASE]: Products.CUSTOM_OBJECTS_LIMIT_INCREASE,
  [DOMAINS_LIMIT_INCREASE]: Products.DOMAINS_LIMIT_INCREASE,
  [SANDBOX_LIMIT_INCREASE]: Products.SANDBOX_LIMIT_INCREASE,
  [ESIGNATURE_LIMIT_INCREASE]: Products.ESIGNATURE_LIMIT_INCREASE,
  [CALLING_LIMIT_INCREASE]: Products.CALLING_LIMIT_INCREASE,
  [PHONE_LIMIT_INCREASE]: Products.PHONE_LIMIT_INCREASE,
  [TEAMS_LIMIT_INCREASE]: Products.TEAMS_LIMIT_INCREASE,
  [WHATSAPP_LIMIT_INCREASE]: Products.WHATSAPP_LIMIT_INCREASE,
  [VIDEO_LIMIT_INCREASE]: Products.VIDEO_LIMIT_INCREASE,
  [CALCULATED_PROPERTIES_LIMIT_INCREASE]: Products.CALCULATED_PROPERTIES_LIMIT_INCREASE,
  [CUSTOM_PROPERTIES_LIMIT_INCREASE]: Products.CUSTOM_PROPERTIES_LIMIT_INCREASE,
  [CRM_OBJECT_LIMIT_INCREASE]: Products.CRM_OBJECT_LIMIT_INCREASE,
  [WORKFLOWS_ADDON]: Products.WORKFLOWS_LIMIT_INCREASE,
  [MARKETING_SMS_ADDON]: Products.MARKETING_SMS,
  [MARKETING_SMS_SHORT_CODE]: Products.MARKETING_SMS_SHORT_CODE,
  [CRM_CONTACT_RECORDS_LIMIT_INCREASE]: Products.NON_MARKETING_CONTACTS_LIMIT_INCREASE,
  [REPORTING]: Products.REPORTING_LIMIT_INCREASE,
  [STARTER_CONTACTS]: Products.MARKETING_HUB_STARTER,
  [CUSTOM_SSL]: Products.WEB_HOSTING_CUSTOM_SSL_PACK,
  [DEDICATED_IP]: Products.TECH_SERVICE_DEDICATED_IP_FOR_EMAIL,
  [BREEZE_INTELLIGENCE_CREDITS_100]: Products.BREEZE_INTELLIGENCE_CREDITS_100,
  [BREEZE_INTELLIGENCE_CREDITS_1000]: Products.BREEZE_INTELLIGENCE_CREDITS_1000,
  [BREEZE_INTELLIGENCE_CREDITS_10000]: Products.BREEZE_INTELLIGENCE_CREDITS_10000,
  [BREEZE_INTELLIGENCE_CREDITS_100_COMMITTED]: Products.BREEZE_INTELLIGENCE_CREDITS_100_COMMITTED,
  [BREEZE_INTELLIGENCE_CREDITS_1000_COMMITTED]: Products.BREEZE_INTELLIGENCE_CREDITS_1000_COMMITTED,
  [BREEZE_INTELLIGENCE_CREDITS_10000_COMMITTED]: Products.BREEZE_INTELLIGENCE_CREDITS_10000_COMMITTED,
  [BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_100]: Products.BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_100,
  [BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_1000]: Products.BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_1000,
  [BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_10000]: Products.BREEZE_INTELLIGENCE_OVERAGE_CREDITS_FOR_10000,
  [HUBSPOT_CREDITS_COMMITTED]: Products.HUBSPOT_CREDITS_COMMITTED,
  [HUBSPOT_CREDITS_COMMITTED_OVERAGE]: Products.HUBSPOT_CREDITS_COMMITTED_OVERAGE,
  [HUBSPOT_CREDITS_OVERAGE]: Products.HUBSPOT_CREDITS_OVERAGE,
  [COMMERCE_PROFESSIONAL]: Products.COMMERCE_HUB_PROFESSIONAL,
  [COMMERCE_ENTERPRISE]: Products.COMMERCE_HUB_ENTERPRISE
};
export default UpgradeProductToApiNameMap;